<template>
  <router-view></router-view>
</template>

<script setup>
import { useMessage } from 'naive-ui';
const message = useMessage();
window.message = message;
</script>
